export default "__VITE_ASSET__3m6Jwk6n__"